const constants = {
  backend_url: "https://usewisptest.azurewebsites.net",
  dev_server: "http://localhost:8000",
};

export default constants;
